export const data = [
  {
    title: 'دسته‌بندی محصولات',
    items: [
      {
        title: 'تجهیزات پسیو شبکه',
        link: '/cat/passive-equipment/',
      },
      {
        title: 'تجهیزات اکتیو',
        link: '/cat/active-equipment/',
      },
      {
        title: 'تجهیزات فیبر نوری',
        link: '/cat/fiberoptic-equipment/',
      },
      {
        title: 'سیم و کابل',
        link: '/cat/wire-and-cable/',
      },
      {
        title: 'تلفن سانترال',
        link: '/cat/central/central-phone/',
      },
    ],
  },
  {
    title: 'خدمات مشتریان',
    items: [
      {
        title: 'درخواست پیش فاکتور',
        link: '/page/enquiry',
      },
      {
        title: 'سوالات متداول',
        link: '/page/faqs',
      },
      {
        title: 'گزارش خرابی در سایت',
        link: '/page/report-a-crash-on-the-site',
      },
      {
        title: 'روش های ارسال سفارش',
        link: '/page/shipping-methods',
      },
      {
        title: 'روش های پرداخت',
        link: '/page/payment-methods',
      },
      {
        title: 'روند بازگرداندن کالا',
        link: '/page/warranty-and-return-terms-of-the-goods',
      },
    ],
  },

  {
    title: 'برقچی',
    items: [
      {
        title: 'چرا برقچی',
        link: '/page/why-us',
      },
      {
        title: 'فرصت های  شغلی',
        link: '/page/career-opportunities',
      },
      {
        title: 'مجله برقچی',
        link: 'https://barghchi.com/mag/',
      },
      {
        title: 'تامین کالا',
        link: '/page/supply-of-goods-for-barghchi',
      },
      {
        title: 'درباره ما',
        link: '/page/about-us',
      },
      {
        title: 'تماس با ما',
        link: '/page/contact-us',
      },
    ],
  },
];
